import { ApolloQueryResult } from '@apollo/client';
import { client } from '@app/core/apolloClient';

import {
  GetBankAccountsDocument,
  GetBankAccountsQuery,
  GetBankAccountsQueryVariables,
} from '@app/common/queries/queryTyping/getAccountList';

import { getHiddenAccountsToggle } from '@app/widgets/bank-accounts/accountLocalSettings/hiddenAccountsToggle';

export enum FetchPolicy {
  CacheFirst = 'cache-first',
  NetworkOnly = 'network-only',
}

export interface GetBankAccountsListProps {
  readonly variables?: GetBankAccountsQueryVariables,
  readonly invalidateApolloCache?: boolean
}

export function getBankAccountsList(
  options?: GetBankAccountsListProps,
): Promise<ApolloQueryResult<GetBankAccountsQuery>> {
  const baseOptions = {
    query: GetBankAccountsDocument,
    variables: {
      includeHiddenInGroups: getHiddenAccountsToggle(),
      invalidateCache: false,
      invalidateApolloCache: false,
    },
    fetchPolicy: FetchPolicy.CacheFirst,
  };

  if (options?.variables) {
    Object.assign(baseOptions.variables, options.variables);
  }

  if (options?.invalidateApolloCache) {
    baseOptions.variables.invalidateApolloCache = true;
    baseOptions.fetchPolicy = FetchPolicy.NetworkOnly;
  }

  return client.query(baseOptions);
}
